import React, { useRef } from "react";
import { useTheme } from "@mui/material";
import DSBox from "../../system-design/DSBox";
import DSTypography from "../../system-design/DSTypography";
import ColorChip from "./ColorChip";

type ColorPickerInputProps = {
  color: string;
  onChange: (color: string) => void;
  label?: string;
  disabled?: boolean;
};

const ColorPickerInput = ({
  color,
  onChange,
  label = "Contrast Color",
  disabled = false,
}: ColorPickerInputProps) => {
  const { palette } = useTheme();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChipClick = () => {
    inputRef.current?.click();
  };

  const handleColorChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <DSBox sx={{ mt: 1, position: "relative" }}>
      <DSTypography
        variant="caption"
        sx={{
          color: palette.text.secondary,
          display: "block",
          mb: 0.5,
        }}
      >
        *{label}
      </DSTypography>
      <DSBox
        onClick={disabled ? undefined : handleChipClick}
        sx={{
          display: "inline-block",
          cursor: disabled ? "not-allowed" : "pointer",
          position: "relative",
          opacity: disabled ? 0.5 : 1,
          "&:hover": {
            opacity: disabled ? 0.5 : 0.8,
          },
        }}
      >
        <ColorChip color={color} />
        <input
          ref={inputRef}
          type="color"
          value={color}
          onChange={handleColorChange}
          disabled={disabled}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            opacity: 0,
            cursor: disabled ? "not-allowed" : "pointer",
          }}
        />
      </DSBox>
    </DSBox>
  );
};

export default ColorPickerInput;
